"use strict";
exports.__esModule = true;
exports.Dates = void 0;
var date_fns_1 = require("date-fns");
var Formats;
(function (Formats) {
    Formats["dateDisplay"] = "dd/MM/yyyy";
    Formats["dateISO"] = "yyyy-MM-dd";
    Formats["datetimeStorage"] = "yyyy-MM-dd_HH-mm-ss";
    Formats["datetimeDisplay"] = "dd/MM/yyyy HH:mm:ss";
    Formats["datetimeISO"] = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
    Formats["timeStorage"] = "HH:mm";
})(Formats || (Formats = {}));
var nowFormattedForStorage = function () { return (0, date_fns_1.format)(Date.now(), Formats.datetimeStorage); };
exports.Dates = {
    nowFormattedForStorage: nowFormattedForStorage
};
//# sourceMappingURL=dates.js.map